/**
 * RegularListContainer
 * --
 */
import React from 'react';
import ShippingList from 'routes/admin.routes/admin.orders/ShippingList';
import { useUserStack } from 'store';

/**----------------------------------------
 * [Component] 쇼핑몰관리자: 정기배송목록 컨테이너
 * ----------------------------------------
 */
const RegularListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ShippingList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          type="SUBSCRIPTION"
        />
      )}
    </>
  );
};

export default RegularListContainer;
